import { useMutation, useQuery } from "@tanstack/react-query";
import {
  grossingRequisitionsService,
  type GrossingDocumentMetadata,
} from "../services/grossingRequisitions.service";

export function useGrossingRequisitions(caseId: string, enabled: boolean) {
  return useQuery<GrossingDocumentMetadata[]>({
    queryKey: ["grossing-requisitions", caseId],
    queryFn: () => grossingRequisitionsService.list(caseId),
    enabled: enabled && Boolean(caseId),
    retry: false,
  });
}

export function useGrossingRequisitionViewUrl() {
  return useMutation({
    mutationFn: ({ caseId, fileId }: { caseId: string; fileId: string }) =>
      grossingRequisitionsService.createViewUrl(caseId, fileId),
  });
}
